import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { InformationPopupPage } from '../../shared/components/information-popup/information-popup.model';

import { AppState } from '../app.state';
import { InformationPopupState, UserPageSettings } from './information-popup.state';

export namespace InformationPopupSelectors {
  export const informationPopupState = (state: AppState): InformationPopupState =>
    state.informationPopup;

  export function getAllPagesSettings(): MemoizedSelector<
    AppState,
    UserPageSettings[],
    DefaultProjectorFn<UserPageSettings[]>
  > {
    return createSelector(
      informationPopupState,
      (state: InformationPopupState) => state.pageSettings
    );
  }

  export function getIsLoaded(): MemoizedSelector<AppState, boolean, DefaultProjectorFn<boolean>> {
    return createSelector(informationPopupState, (state: InformationPopupState) => state.loaded);
  }

  export function getPageSettings(
    page: InformationPopupPage
  ): MemoizedSelector<AppState, UserPageSettings, DefaultProjectorFn<UserPageSettings>> {
    return createSelector(informationPopupState, (state: InformationPopupState) => {
      if (state.loaded) {
        return state.pageSettings?.find((entry) => entry.page === page);
      } else {
        return null;
      }
    });
  }
}
